(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-lp-banner"] && !Shopify.designMode) return;
  try {
    
  const b2bLpBannerSlideCount = document.querySelectorAll('.b2b-lp-banner__slider .swiper-slide').length;
  const b2bLpBannerSlider = new Swiper('.b2b-lp-banner__slider', {
    slidesPerView: 1,
    watchOverflow: true,
    loop: b2bLpBannerSlideCount > 1,
    spaceBetween: 20,
    allowTouchMove: true,
    preventClicks: false,
    preventClicksPropagation: false,
    autoplay:
      b2bLpBannerSlideCount > 1
        ? {
            delay: 5000,
          }
        : false,
    pagination: {
      el: '.b2b-lp-banner__pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        allowTouchMove: false,
      },
    },
    on: {
      init: function () {
        const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const elementWithDataIdx0 = document.querySelector('.b2b-lp-banner__image[data-idx="0"]');
        if (elementWithDataIdx0) {
          let firstImageRatio;
          if (windowWidth < 768) {
            firstImageRatio = elementWithDataIdx0.querySelector('.aspect-ratio.hide-desktop');
          } else {
            firstImageRatio = elementWithDataIdx0.querySelector('.aspect-ratio.hide-mobile');
          }

          if (firstImageRatio) {
            const firstImagecomputedStyle = window.getComputedStyle(firstImageRatio);
            const firstImagepaddingBottom = parseFloat(firstImagecomputedStyle.paddingBottom);

            const bannerElement = document.querySelector('.b2b-lp-banner');
            const isMobile = windowWidth < 768;
            const imageHeightSetting = isMobile 
              ? bannerElement?.getAttribute('data-image-height-mobile')
              : bannerElement?.getAttribute('data-image-height-desktop');

            if (bannerElement && imageHeightSetting === 'image_adaptive') {
              bannerElement.style.height = firstImagepaddingBottom + 'px';
            }
          }
        }
      },
    },
  });

  function aspectHeightB2bLpBanner(activeImage) {
    if (!activeImage) return;

    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    let aspectRatioElement;
    if (windowWidth < 768) {
      aspectRatioElement = activeImage.querySelector('.aspect-ratio.hide-desktop');
    } else {
      aspectRatioElement = activeImage.querySelector('.aspect-ratio.hide-mobile');
    }

    if (aspectRatioElement) {
      const computedStyle = window.getComputedStyle(aspectRatioElement);
      const paddingBottom = parseFloat(computedStyle.paddingBottom);

      const bannerElement = document.querySelector('.b2b-lp-banner');
      const isMobile = windowWidth < 768;
      const imageHeightSetting = isMobile 
        ? bannerElement?.getAttribute('data-image-height-mobile')
        : bannerElement?.getAttribute('data-image-height-desktop');

      if (bannerElement && imageHeightSetting === 'image_adaptive') {
        bannerElement.style.height = paddingBottom + 'px';
      }
    }
  }

  b2bLpBannerSlider.on('slideChange', function (slider) {
    const idx = slider.realIndex;
    const currentActive = document.querySelector('.b2b-lp-banner__image.active');
    if (currentActive) {
      currentActive.classList.remove('active');
    }
    const activeImage = document.querySelector(`.b2b-lp-banner__image[data-idx="${idx}"]`);
    if (activeImage) {
      activeImage.classList.add('active');
      aspectHeightB2bLpBanner(activeImage);
    }
  });

  window.addEventListener('resize', () => {
    const activeUpdateImage = document.querySelector('.b2b-lp-banner__image.active');
    aspectHeightB2bLpBanner(activeUpdateImage);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-testimonials"] && !Shopify.designMode) return;
  try {
    
  const testimonialLogoSlider = new Swiper('.testimonial-slider__logo-container', {
    slidesPerView: 1,
    watchOverflow: true,
    loop: true,
    spaceBetween: 20,
    effect: 'fade',
    speed: 600,
    allowTouchMove: true,
    fadeEffect: {
      crossFade: true
    },
    breakpoints: {
      768: {
        speed: 1000
      }
    }
  });

  // Determine navigation selectors based on style and screen size
  const isStyle2 = document.querySelector('.testimonial-slider--style-2');
  const mobilePrevEl = document.querySelector('.testimonial-slider--style-2-mobile-prev');
  const mobileNextEl = document.querySelector('.testimonial-slider--style-2-mobile-next');
  
  // Use mobile arrows for style 2 on mobile, desktop arrows otherwise
  const getNavSelectors = () => {
    if (window.innerWidth <= 768 && isStyle2 && mobilePrevEl && mobileNextEl) {
      return {
        prevEl: '.testimonial-slider--style-2-mobile-prev',
        nextEl: '.testimonial-slider--style-2-mobile-next'
      };
    }
    return {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next'
    };
  };

  const navSelectors = getNavSelectors();

  const testimonialSlider = new Swiper('.testimonial-slider__container', {
    slidesPerView: 1,
    watchOverflow: true,
    loop: true,
    spaceBetween: 20,
    speed: 600,
    autoplay: {
      delay: 3000
    },
    navigation: navSelectors,
    pagination: {
      el: '.testimonial-slider .swiper-pagination'
    },
    controller: {
      control: testimonialLogoSlider
    },
    breakpoints: {
      769: {
        speed: 1000,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["divider"] && !Shopify.designMode) return;
  try {
    
  gsap.from('.divider__line-1', { 
    rotation: -.5,
    duration: 4,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  gsap.from('.divider__line-2', { 
    rotation: .5,
    duration: 4,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-popup"] && !Shopify.designMode) return;
  try {
    
  const newsletterPopup = document.querySelector('.newsletter-popup-wrapper');
  const newsletterPopupClose = document.querySelector('.newsletter-popup__close');
  const newsletterPopupOpen = document.querySelectorAll('[href="#open-newsletter"]');

  if (newsletterPopup) {

    if (getCookie('newsletterCookie')) {
      fadeOut(newsletterPopup, 400)
    } else {
      const delay = (Number(newsletterPopup.dataset.delay) * 1000) || 5000;

      setTimeout(function() {
        fadeIn(newsletterPopup, 400, 'flex');
      }, delay);
    }

    newsletterPopupClose.addEventListener('click', event => {
      const day = 1;

      fadeOut(newsletterPopup, 400)
      setCookie('newsletterCookie', true, day);
    });

    newsletterPopupOpen.forEach(btn => {
      btn.addEventListener('click', event => {
        newsletterPopup.classList.add('is-visible');
      });
    });

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explore-products"] && !Shopify.designMode) return;
  try {
    
  // Animations
  let exploreTL = gsap.timeline({
    scrollTrigger: {
      duration: 1,
      trigger: '.explore-products__images-wrapper',
      start: "top 80%"
    }
  });

  animateImageSection(1);
  function animateImageSection(idx) {
    exploreTL.from(`.explore-products__images-wrapper[data-index="${idx}"]`, {
      opacity: 0,
      y: 25,
      delay: .35
    })
    .to(`.explore-products__arrow-1[data-index="${idx}"]`, {
      x: 0,
      opacity: 1
    }, '<90%')
    .to(`.explore-products__arrow-2[data-index="${idx}"]`, {
      x: 0,
      opacity: 1
    }, '<90%');
  }

  gsap.fromTo('.explore-products__line',
    {
      drawSVG: '0% 0%'
    },
    {
      drawSVG: '0% 100%',
      duration: 3.5,
      delay: 1,
      scrollTrigger: {
        trigger: '.explore-products__line',
        start: "top 80%"
      }
    }
  );

  const exploreInfoSlider = new Swiper('.explore-products__information-wrapper', {
    loop: false,
    spaceBetween: 20,
    effect: 'fade',
    allowTouchMove: false,
    speed: 800
  });

  const exploreImageSlider = new Swiper('.explore-products__images-wrapper', {
    loop: false,
    spaceBetween: 20,
    effect: 'fade',
    allowTouchMove: false,
    speed: 800
  });

  const exploreTabs = document.querySelectorAll('.explore-products__tab');
  exploreTabs.forEach(tab => {
    tab.addEventListener('click', event => {
      const activeSibling = event.target.parentElement.querySelector('.active');
      const idx = Number(event.target.dataset.idx);
      
      // Active tab state
      activeSibling.classList.remove('active');
      event.target.classList.add('active');

      // Sync with sliders 
      exploreInfoSlider.slideTo(idx);
      exploreImageSlider.slideTo(idx);

      // Run Animation
      animateImageSection(idx + 1);
    });
  }); 

  //Image hide sshow function
  const images = document.querySelectorAll(".image__wrap")
  function toggleHideClass() {
    images.forEach(image => image.classList.toggle("image__hide"));
  }
  setInterval(toggleHideClass, 5000);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  // Animations
  let exploreTL = gsap.timeline({
    scrollTrigger: {
      duration: 1,
      trigger: '.Featured_Product_Section .product__media-wrapper .product__media-list',
      start: "top 80%"
    }
  });

  animateImageSection(1);
  function animateImageSection(idx) {
    exploreTL.from(`.Featured_Product_Section .product__media-wrapper .product__media-list[data-index="${idx}"]`, {
      opacity: 0,
      y: 25,
      delay: .35
    })
    .to(`.explore-products__arrow-1[data-index="${idx}"]`, {
      x: 0,
      opacity: 1
    }, '<90%')
    .to(`.explore-products__arrow-2[data-index="${idx}"]`, {
      x: 0,
      opacity: 1
    }, '<90%');
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Mobile accordion: one menu open at a time. On desktop all menus are expanded via CSS.
  const footerDesktopQuery = window.matchMedia('(min-width: 769px)');
  const footerMenuButtons = document.querySelectorAll('.footer-ab .footer-block__heading-container');

  // Keep aria-expanded in sync: always expanded on desktop, mirrors the .active state on mobile.
  const syncFooterAccordionState = () => {
    footerMenuButtons.forEach(footerButton => {
      const block = footerButton.closest('.footer-block--menu');
      const expanded = footerDesktopQuery.matches || block.classList.contains('active');
      footerButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  };

  footerMenuButtons.forEach(footerButton => {
    footerButton.addEventListener('click', event => {
      if (footerDesktopQuery.matches) return;

      const parent = event.currentTarget.closest('.footer-block--menu');
      const content = parent.querySelector('.footer-block__details-content');
      const activeDropdown = document.querySelector('.footer-ab .footer-block--menu.active');

      if (!content) return;

      if (!parent.classList.contains('active')) {
        if (activeDropdown) {
          const activeContent = activeDropdown.querySelector('.footer-block__details-content');

          activeDropdown.classList.remove('active');
          if (activeContent) slideUp(activeContent, 300);
        }

        parent.classList.add('active');
        slideDown(content, 300);
      } else {
        parent.classList.remove('active');
        slideUp(content, 300);
      }

      syncFooterAccordionState();
    });
  });

  syncFooterAccordionState();
  footerDesktopQuery.addEventListener('change', syncFooterAccordionState);

  // Newsletter: after a submit, smoothly scroll to the success (or error) message instead of the
  // native #newsletter_v2 anchor jump.
  const footerNewsletterForm = document.querySelector('.footer-ab .footer__newsletter-form');
  if (footerNewsletterForm) {
    const footerNewsletterAction = footerNewsletterForm.getAttribute('action') || '';
    if (footerNewsletterAction.indexOf('#') !== -1) {
      footerNewsletterForm.setAttribute('action', footerNewsletterAction.split('#')[0]);
    }
  }

  const scrollFooterToNewsletterMessage = () => {
    const newsletter = document.querySelector('.footer-ab .footer__newsletter');
    if (!newsletter) return;
    const message = newsletter.querySelector('.newsletter-form__message--success')
      || newsletter.querySelector('.newsletter-form__message');
    if (!message) return;
    window.setTimeout(() => {
      message.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (typeof message.focus === 'function') message.focus({ preventScroll: true });
    }, 250);
  };

  // The bundled section script can run after the load event has already fired.
  if (document.readyState === 'complete') {
    scrollFooterToNewsletterMessage();
  } else {
    window.addEventListener('load', scrollFooterToNewsletterMessage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-backup"]) return;
  try {
    
  // B2B Account Dropdown
  const b2bTrigger = document.querySelector('.header__b2b-account-trigger');
  if (b2bTrigger) {
    const b2bAccount = b2bTrigger.closest('.header__b2b-account');
    const dropdown = b2bAccount.querySelector('.header__b2b-dropdown');
    const closeBtn = dropdown.querySelector('.header__b2b-dropdown-close');
    let overlay = document.querySelector('.header__b2b-dropdown-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'header__b2b-dropdown-overlay';
      document.body.appendChild(overlay);
    }

    function isMobile() {
      return window.innerWidth < 850;
    }

    function setMobileTop() {
      const navWrapper = document.querySelector('.navigation-wrapper');
      if (navWrapper && isMobile()) {
        const rect = navWrapper.getBoundingClientRect();
        const top = rect.bottom;
        dropdown.style.setProperty('--b2b-dropdown-top', top + 'px');
      }
    }

    function openDropdown() {
      if (isMobile()) {
        setMobileTop();
        document.body.appendChild(dropdown);
      }
      dropdown.classList.add('is-open');
      overlay.classList.add('is-open');
      b2bTrigger.setAttribute('aria-expanded', 'true');
      dropdown.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDropdown() {
      dropdown.classList.remove('is-open');
      overlay.classList.remove('is-open');
      b2bTrigger.setAttribute('aria-expanded', 'false');
      dropdown.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (dropdown.parentNode !== b2bAccount) {
        b2bAccount.appendChild(dropdown);
      }
    }

    b2bTrigger.addEventListener('click', () => {
      if (dropdown.classList.contains('is-open')) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });

    closeBtn.addEventListener('click', closeDropdown);
    overlay.addEventListener('click', closeDropdown);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && dropdown.classList.contains('is-open')) {
        closeDropdown();
        b2bTrigger.focus();
      }
    });

    document.addEventListener('click', (e) => {
      if (!b2bAccount.contains(e.target) && !dropdown.contains(e.target) && dropdown.classList.contains('is-open')) {
        closeDropdown();
      }
    });
  }

  // Transparent header
  const header = document.querySelector('.navigation-wrapper');
  let scrollPosition = window.scrollY;

  if (scrollPosition > 5) {
    header.classList.add('scrolled')
  } else {
    header.classList.remove('scrolled')
  }

  document.addEventListener('scroll', () => {
    scrollPosition = window.scrollY;

    if (scrollPosition > 5) {
      header.classList.add('scrolled')
    } else {
      header.classList.remove('scrolled')
    }
  });

  // Megamenu overlay
  const height = document.querySelector('.navigation-wrapper').offsetHeight;
  const overlays = document.querySelectorAll('.header__mega-menu-overlay');
  overlays.forEach(overlay => {
    overlay.style.top = `${height}px`;
  })
  
  // Megamenu hover categories
  const hoverCategories = document.querySelectorAll('.header__mega-menu-category');

  hoverCategories.forEach(hoverCategory => {
    hoverCategory.addEventListener('mouseenter', event => {
      const tab = event.currentTarget.dataset.tab;
      const activeHoverCategory = event.currentTarget.parentElement.querySelector('.header__mega-menu-category.active');

      activeHoverCategory?.classList.remove('active');
      event.currentTarget?.classList.add('active');

      const categorySections = document.querySelectorAll('.header__mega-menu-category-products');
      const activeSection = document.querySelector('.header__mega-menu-category-products.active');
      const targetSection = document.querySelector(`.header__mega-menu-category-products[data-tab="${tab}"]`);

      activeSection?.classList.remove('active');
      targetSection?.classList.add('active');
    });
  });

  // Search
  const openSearch = document.querySelector('.js-open-search');
  const closeSearch = document.querySelector('.js-close-search');
  const search = document.querySelector('.header__search');

  openSearch.addEventListener('click', () => {
    if (search.classList.contains('is-visible')) {
      search.classList.remove('is-visible');
    } else {
      search.classList.add('is-visible');
    }
  });

  closeSearch.addEventListener('click', () => {
    search.classList.remove('is-visible');
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // B2B Account Dropdown
  const b2bTrigger = document.querySelector('.header__b2b-account-trigger');
  if (b2bTrigger) {
    const b2bAccount = b2bTrigger.closest('.header__b2b-account');
    const dropdown = b2bAccount.querySelector('.header__b2b-dropdown');
    const closeBtn = dropdown.querySelector('.header__b2b-dropdown-close');
    // Create overlay
    let overlay = document.querySelector('.header__b2b-dropdown-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'header__b2b-dropdown-overlay';
      document.body.appendChild(overlay);
    }

    function isMobile() {
      return window.innerWidth < 990;
    }

    function setMobileTop() {
      const navWrapper = document.querySelector('.navigation-wrapper');
      if (navWrapper && isMobile()) {
        const rect = navWrapper.getBoundingClientRect();
        const top = rect.bottom;
        dropdown.style.setProperty('--b2b-dropdown-top', top + 'px');
      }
    }

    function openDropdown() {
      if (isMobile()) {
        // Move dropdown to body so it escapes header stacking context
        setMobileTop();
        document.body.appendChild(dropdown);
      }
      dropdown.classList.add('is-open');
      overlay.classList.add('is-open');
      b2bTrigger.setAttribute('aria-expanded', 'true');
      dropdown.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDropdown() {
      dropdown.classList.remove('is-open');
      overlay.classList.remove('is-open');
      b2bTrigger.setAttribute('aria-expanded', 'false');
      dropdown.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Move dropdown back into header if it was moved
      if (dropdown.parentNode !== b2bAccount) {
        b2bAccount.appendChild(dropdown);
      }
    }

    b2bTrigger.addEventListener('click', () => {
      if (dropdown.classList.contains('is-open')) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });

    closeBtn.addEventListener('click', closeDropdown);
    overlay.addEventListener('click', closeDropdown);

    // Close on escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && dropdown.classList.contains('is-open')) {
        closeDropdown();
        b2bTrigger.focus();
      }
    });

    // Close on click outside (desktop)
    document.addEventListener('click', (e) => {
      if (!b2bAccount.contains(e.target) && !dropdown.contains(e.target) && dropdown.classList.contains('is-open')) {
        closeDropdown();
      }
    });
  }

  // Transparent header
  const header = document.querySelector('.navigation-wrapper');
  let scrollPosition = window.scrollY;

  if (scrollPosition > 5) {
    header.classList.add('scrolled')
  } else {
    header.classList.remove('scrolled')
  }

  document.addEventListener('scroll', () => {
    scrollPosition = window.scrollY;

    if (scrollPosition > 5) {
      header.classList.add('scrolled')
    } else {
      header.classList.remove('scrolled')
    }
  });

  // Megamenu overlay
  const height = document.querySelector('.navigation-wrapper').offsetHeight;
  const overlays = document.querySelectorAll('.header__mega-menu-overlay');
  overlays.forEach(overlay => {
    overlay.style.top = `${height}px`;
  })
  
  // Megamenu hover categories
  const hoverCategories = document.querySelectorAll('.header__mega-menu-category');

  hoverCategories.forEach(hoverCategory => {
    hoverCategory.addEventListener('mouseenter', event => {
      const tab = event.currentTarget.dataset.tab;
      const activeHoverCategory = event.currentTarget.parentElement.querySelector('.header__mega-menu-category.active');

      activeHoverCategory?.classList.remove('active');
      event.currentTarget?.classList.add('active');

      const categorySections = document.querySelectorAll('.header__mega-menu-category-products');
      const activeSection = document.querySelector('.header__mega-menu-category-products.active');
      const targetSection = document.querySelector(`.header__mega-menu-category-products[data-tab="${tab}"]`);

      activeSection?.classList.remove('active');
      targetSection?.classList.add('active');
    });
  });

  // Mobile drawer newsletter: data-newsletter-sticky="false" moves it to the end of the
  // scrolling menu area (scrolls with the menu); "true" keeps it pinned at the drawer bottom
  (function() {
    const newsletter = document.querySelector('.menu-drawer__newsletter[data-newsletter-sticky]');
    const inner = newsletter?.closest('.menu-drawer__inner');
    const content = inner?.querySelector('.menu-drawer__content');
    if (!content) return;

    function placeNewsletter() {
      const target = newsletter.dataset.newsletterSticky === 'false' ? content : inner;
      if (newsletter.parentElement !== target) target.appendChild(newsletter);
    }

    placeNewsletter();
    new MutationObserver(placeNewsletter).observe(newsletter, {
      attributes: true,
      attributeFilter: ['data-newsletter-sticky'],
    });
  })();

  // Search
  const openSearch = document.querySelector('.js-open-search');
  const closeSearch = document.querySelector('.js-close-search');
  const search = document.querySelector('.header__search');

  // Accessibility: Escape closes an open desktop dropdown / mega menu (hover or keyboard)
  // and returns focus to its top-level item; it reopens on the next hover or focus
  (function() {
    const menuItems = document.querySelectorAll('.header__menu-list > li:not(.header__mega-menu-overlay)');

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openItem = document.activeElement?.closest('.header__menu-list > li')
        || Array.from(menuItems).find((item) => item.matches(':hover'));
      if (!openItem) return;
      openItem.classList.add('is-dismissed');
      openItem.querySelector('a, [tabindex="0"]')?.focus();
    });

    menuItems.forEach((item) => {
      item.addEventListener('mouseleave', () => item.classList.remove('is-dismissed'));
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) item.classList.remove('is-dismissed');
      });
    });
  })();

  // Accessibility: keep aria-expanded in sync, move focus into the field on open,
  // return it to the toggle on close, and close on Escape
  function setSearchOpen(isOpen) {
    search.classList.toggle('is-visible', isOpen);
    openSearch.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (isOpen) {
      setTimeout(() => search.querySelector('input[type="search"]')?.focus(), 50);
    } else if (search.contains(document.activeElement)) {
      openSearch.focus();
    }
  }

  // Guard: these elements only exist when "Enable Search" is on
  if (openSearch && search) {
    openSearch.addEventListener('click', () => {
      setSearchOpen(!search.classList.contains('is-visible'));
    });

    closeSearch?.addEventListener('click', () => setSearchOpen(false));

    search.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setSearchOpen(false);
    });
  }
  
    // BSS Countdown Banner: on mobile, switch navigation-wrapper from sticky to fixed
  // and offset it by the total height of visible bss-countdown-banner elements.
  (function() {
    function isMobileViewport() {
      return window.innerWidth < 990;
    }

    function adjustNavForCountdownBanner() {
      const navWrapper = document.querySelector('.navigation-wrapper');
      if (!navWrapper) return;

      // Outside of mobile, always release any inline overrides we set below.
      if (!isMobileViewport()) {
        navWrapper.style.position = '';
        navWrapper.style.top = '';
        navWrapper.style.left = '';
        navWrapper.style.right = '';
        return;
      }

      const banners = document.querySelectorAll('bss-countdown-banner');
      let totalHeight = 0;

      banners.forEach(function(banner) {
        const style = window.getComputedStyle(banner);
        if (style.display !== 'none') {
          totalHeight += banner.getBoundingClientRect().height;
        }
      });

      if (totalHeight > 0) {
        // Banner is in flow (BSS uses position: relative), so we only need to
        // pull the nav-wrapper out of flow and seat it just below the banner.
        // The actual #MainContent margin-top is handled by the global sync
        // routine in assets/global.js, which uses navWrapper.offsetHeight
        // (the source of truth for the nav's rendered height).
        navWrapper.style.position = 'fixed';
        navWrapper.style.top = totalHeight + 'px';
        navWrapper.style.left = '0';
        navWrapper.style.right = '0';
      } else {
        navWrapper.style.position = '';
        navWrapper.style.top = '';
        navWrapper.style.left = '';
        navWrapper.style.right = '';
      }
    }

    // Run on load
    adjustNavForCountdownBanner();

    // Re-run on resize in case viewport crosses the mobile breakpoint
    window.addEventListener('resize', adjustNavForCountdownBanner);

    // Watch for bss-countdown-banner being injected or toggled by the app
    const observer = new MutationObserver(function() {
      adjustNavForCountdownBanner();
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-discounts"] && !Shopify.designMode) return;
  try {
    
  // Prevent scrolling to top of page
  const links = document.querySelectorAll('.hero-discounts__block-button');
  links.forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  
  const heroSlider = new Swiper('.hero__slider', {
    slidesPerView: 1,
    watchOverflow: true,
    loop: true,
    spaceBetween: 20,
    allowTouchMove: true, 
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: '.hero__pagintation',
      clickable: true
    },
    breakpoints: {
      768: {
        allowTouchMove: false
      }
    },
    on: {
      init: function () {
        var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var elementWithDataIdx0 = document.querySelector('.hero__image[data-idx="0"]');
        if (windowWidth < 768) {
          var firstImageRatio = elementWithDataIdx0.querySelector('.aspect-ratio.hide-desktop');
        } 
        else {
          var firstImageRatio = elementWithDataIdx0.querySelector('.aspect-ratio.hide-mobile');
        }        
        var firstImagecomputedStyle = window.getComputedStyle(firstImageRatio);
        var firstImagepaddingBottom = parseFloat(firstImagecomputedStyle.paddingBottom);

        var image_adaptiv_one = document.querySelector('.image_adaptive');

        if (image_adaptiv_one) {
          document.querySelector('.image_adaptive').style.height = firstImagepaddingBottom + 'px';
        }
      },
    }
  });
  
  function aspectHeight(activeImage) {
   var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
     if (windowWidth < 768) {
      var aspectRatioElement = activeImage.querySelector('.aspect-ratio.hide-desktop');
    } 
    else {
      var aspectRatioElement = activeImage.querySelector('.aspect-ratio.hide-mobile');
    }
    var computedStyle = window.getComputedStyle(aspectRatioElement);
    var paddingBottom = parseFloat(computedStyle.paddingBottom);
    

    var image_adaptive = document.querySelector('.image_adaptive');

    if(image_adaptive){
      document.querySelector('.image_adaptive').style.height = paddingBottom + 'px';    
    }
    
  }
  
  heroSlider.on('slideChange', function (slider) {
    const idx = slider.realIndex;
    document.querySelector('.hero__image.active').classList.remove('active');
    var activeImage = document.querySelector(`.hero__image[data-idx="${idx}"]`);
    activeImage.classList.add('active');
    aspectHeight(activeImage);
  });  
  
  window.addEventListener('resize', () => {
    var activeUpdateImage = document.querySelector('.hero__image.active');
    aspectHeight(activeUpdateImage);
  });

  gsap.from('.opaque-white-shape', { 
    y: 30,
    duration: 4,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  gsap.from('.transparent-white-shape', { 
    y: -20,
    duration: 4,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  gsap.set('.hero__svg .line', { visibility: 'visible' });
  gsap.fromTo('.hero__svg .line',
    { drawSVG: '100% 100%', duration: 3.5, delay: 1 },
    { drawSVG: '0% 100%', duration: 3.5, delay: 1 }
  );
  
  gsap.from('.hero__svg .line-1', { 
    y: -35,
    duration: 5,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  gsap.from('.hero__svg .line-2', { 
    y: -15,
    duration: 5,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
    if( document.querySelector(".image-banner__stroke") ){
        gsap.set('.image-banner__stroke .page-divider .divider-line', { visibility: 'visible' });
        gsap.fromTo('.image-banner__stroke.line-position-top .divider-line',
            { drawSVG: '100% 100%', duration: 3.5, delay: 1 },
            { drawSVG: '0% 100%', duration: 3.5, delay: 1 }
        );

        gsap.fromTo('.image-banner__stroke.line-position-bottom .divider-line',
            { drawSVG: '0% 0%', duration: 3.5, delay: 1 },
            { drawSVG: '100% 0%', duration: 3.5, delay: 1 }
        );

        gsap.from('.image-banner__stroke .divider__line-1', { 
            rotation: -.5,
            duration: 4,
            ease: 'linear',
            repeat: -1,
            yoyo: true
        });

        gsap.from('.image-banner__stroke .divider__line-2', { 
            rotation: .5,
            duration: 4,
            ease: 'linear',
            repeat: -1,
            yoyo: true
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["l-series-gallery-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const videoWrapper = document.querySelector(".video-wrapper");
    const video = videoWrapper.querySelector("video");
    const playButton = videoWrapper.querySelector(".play-button");
  
    function togglePlay() {
      if (video.paused) {
        video.play();
        playButton.style.display = "none"; // Hide button when playing
      } else {
        video.pause();
        playButton.style.display = "block"; // Show button when paused
      }
    }
  
    // Click on the play button
    playButton.addEventListener("click", togglePlay);
  
    // Click on the video itself to play/pause
    video.addEventListener("click", togglePlay);
  
    video.addEventListener("pause", function () {
      playButton.style.display = "block";
    });
  
    video.addEventListener("play", function () {
      playButton.style.display = "none";
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["l-series-main-product"]) return;
  try {
    


  // Description Tabs
  document.addEventListener("DOMContentLoaded", function () {
    var tabs = document.querySelectorAll(".l-series__tabs .tabs li");
    var tabContents = document.querySelectorAll(".l-series__tabs .tab-content");
  
    if (tabs.length > 0) {
      // Set the first tab and content as active by default
      tabs[0].classList.add("current");
      if (tabContents.length > 0) {
        tabContents[0].classList.add("current");
      }
  
      tabs.forEach(function (tab) {
        var tab_id = tab.getAttribute("data-tab"); 
        let check_bundle = tab.closest('.l-series__tabs').querySelector('[id^="qbk-bundle-offer"]');
        let check_inner_bundle = tab.closest('.l-series__tabs').querySelector('[mountid^="qbk-bundle-offer"]');
        tab.addEventListener("click", function () {
           
          // Remove 'current' class from all tabs and tab content
          tabs.forEach(function (t) {
            t.classList.remove("current");
          });
          tabContents.forEach(function (content) {
            content.classList.remove("current");
          });
  
          // Add 'current' class to the clicked tab and corresponding tab content
          tab.classList.add("current");
          var activeContent = document.getElementById(tab_id);
          if (activeContent) {
            activeContent.classList.add("current");
          }
        });
      });
    }

    // Cache the original element reference
    let bundleElement = document.querySelector(".desktop__tab--bundle > div");
    
    // Function to move the bundle element
    function moveBundleElement() {
      const screenWidth = window.innerWidth;
    
      const desktopContainer = document.querySelector(".desktop__tab--bundle");
      const mobileContainer = document.querySelector('.l__series--accordion > [data-title="bundle"] .mobile__tab--bundle');
    
      if (!bundleElement || !desktopContainer || !mobileContainer) return;
    
      if (screenWidth >= 769 && desktopContainer.contains(bundleElement) === false) {
        desktopContainer.innerHTML = ""; // Clear to avoid duplicates
        desktopContainer.appendChild(bundleElement);
      } else if (screenWidth < 769 && mobileContainer.contains(bundleElement) === false) {
        mobileContainer.innerHTML = ""; // Clear to avoid duplicates
        mobileContainer.appendChild(bundleElement);
      }
    }
    
    // Run on load
    moveBundleElement();
    
    // Run on resize (with debounce for performance)
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        moveBundleElement();
      }, 150);
    });
  });


  // Slider match height
  function updateDotsHeight() {
    var mediaHeight = $('.l-series__product .product__media-item.slick-active').outerHeight();
    if (mediaHeight) {
      $('.l-series__product .slick-dots').css('height', (mediaHeight - 20) + 'px');
    }
  }  
  $(document).ready(function () {
    updateDotsHeight(); // Initial update

    // Run on window resize
    $(window).on('resize', updateDotsHeight);

    // Run every time the Slick slider changes slides
    $('.l-series__tabs .your-slick-slider').on('afterChange', function () {
        updateDotsHeight();
    });

    // Periodically check and update height (optional but helpful for dynamic content)
    setInterval(updateDotsHeight, 500);
  });
  


  // Product zoom slider
  const productZoomSlider = new Swiper('.product__zoom-slider', {
    loop: true,
    pagination: {
      el: '.product__zoom-pagination',
    },
    navigation: {
      nextEl: '.product__zoom-button.swiper-button-next',
      prevEl: '.product__zoom-button.swiper-button-prev',
    }
  });

  const zoomContainer = document.querySelector('.product__zoom');
  const zoomButtons = document.querySelectorAll('.product__media-zoom');
  zoomButtons.forEach(zoomButton => {
    zoomButton.addEventListener('click', event => {
      const position = Number(event.currentTarget.dataset.position) - 1;

      productZoomSlider.slideToLoop(position);
      setTimeout(() => {
        zoomContainer.classList.add('open');
      }, 250);
    });
  });

  const zoomClose = document.querySelector('.product__zoom-close');
  zoomClose.addEventListener('click', event => {
    zoomContainer.classList.remove('open');
  });

  // Product option dropdowns
  const formDropdownButtons = document.querySelectorAll('.product-form__dropdown-text');
  formDropdownButtons.forEach(formDropdownButton => {
    formDropdownButton.addEventListener('click', event => {
      event.preventDefault();

  	  const dropdown = event.currentTarget.nextElementSibling;
      const parent = event.currentTarget.parentElement;

      if (parent.classList.contains('active')) {
  		parent.classList.remove('active');
        slideUp(dropdown);
      } else {
  		parent.classList.add('active');
        slideDown(dropdown, 200)
      }
    });
  });

  const formDropdownLabels = document.querySelectorAll('.product-form__dropdown-container input[type=radio]+label');
  formDropdownLabels.forEach(formDropdownLabel => {
    formDropdownLabel.addEventListener('click', event => {

      const parent = formDropdownLabel.closest('.product-form__dropdown-wrapper')
      const currentText = formDropdownLabel.innerHTML;
      const newText = parent.querySelector('.product-form__dropdown-text span');

  	  newText.innerHTML = currentText;

  	  const activeDropdown = parent.querySelector('.product-form__dropdown-container')
      parent.classList.remove('active');
      slideUp(activeDropdown, 200);
    });
  });


  // Product dropdowns
  const dropdownButtons = document.querySelectorAll('.product__dropdown-header');

  dropdownButtons.forEach(dropdownButton => {
    dropdownButton.addEventListener('click', event => {
      const parent = event.currentTarget.parentElement;
      const content = parent.querySelector('.product__dropdown-content');
      const activeDropdown = document.querySelector('.product__dropdown.active');

      if (!parent.classList.contains('active')) {
        if (activeDropdown) {
          const activeContent = activeDropdown.querySelector('.product__dropdown-content');

          activeDropdown.classList.remove('active');
          slideUp(activeContent, 300);
        }

        parent.classList.add('active');
        slideDown(content, 300);
      } else {
        parent.classList.remove('active');
        slideUp(content, 300);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["l-series-pdp-comparison"] && !Shopify.designMode) return;
  try {
    
  const comparisonSlider = new Swiper('.pdp-comparison__charts-mobile', {
    slidesPerView: 2,
    watchOverflow: true,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["l-series-specifications"] && !Shopify.designMode) return;
  try {
    

  var swiper = new Swiper(".specifications__slider--inner", {
    pagination: {
      el: ".specifications-pagination",
    },
    navigation: {
      nextEl: ".specifications-button-next",
      prevEl: ".specifications-button-prev",
    },
  });

  var swiperImageText = new Swiper(".image__text--slider--inner", {
    slidesPerView: 2,
    spaceBetween: 20,
    pagination: {
      el: ".image-slider-pagination",
    },
    navigation: {
      nextEl: ".image-slider-button-next",
      prevEl: ".image-slider-button-prev",
    },
    breakpoints: {
      769: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 40,
      },
    }
  });
  
document.addEventListener("DOMContentLoaded", function () {
  var tabs = document.querySelectorAll(".specifications-tab-link");
  var tabContents = document.querySelectorAll(".specifications-tab-content");

  if (tabs.length > 0) {
    // Set the first tab and content as active by default
    tabs[0].classList.add("active");
    if (tabContents.length > 0) {
      tabContents[0].classList.add("active");
    }

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var tab_id = tab.getAttribute("data-tab");

        // Remove 'active' class from all tabs and tab content
        tabs.forEach(function (t) {
          t.classList.remove("active");
        });
        tabContents.forEach(function (content) {
          content.classList.remove("active");
        });

        // Add 'active' class to the clicked tab and corresponding tab content
        tab.classList.add("active");
        var activeContent = document.getElementById(tab_id);
        if (activeContent) {
          activeContent.classList.add("active");
        }
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-collections"] && !Shopify.designMode) return;
  try {
    
    function smoothScroll(target) {
    const element = document.getElementById(target);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 100,
        behavior: 'smooth'
      });
    }
  }
  
  const anchors = document.querySelectorAll('a[href^="#"]');
  anchors.forEach(function(anchor) {
    anchor.addEventListener('click', function(event) {
      event.preventDefault();
      const target = anchor.getAttribute('href').substring(1);
      smoothScroll(target);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-hero"] && !Shopify.designMode) return;
  try {
    
  
  function aspectHeight(activeImage) {
    console.log('Script is running 555');
    
   var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
     if (windowWidth < 768) {
      var aspectRatioElement = activeImage.querySelector('.aspect-ratio.hide-desktop');
    } 
    else {
      var aspectRatioElement = activeImage.querySelector('.aspect-ratio.hide-mobile');
    }
    var computedStyle = window.getComputedStyle(aspectRatioElement);
    var paddingBottom = parseFloat(computedStyle.paddingBottom);
    

    var image_adaptive = document.querySelector('.image_adaptive');

    if(image_adaptive){
      document.querySelector('.image_adaptive').style.height = paddingBottom + 'px';    
    }
    
  }
  
  heroSlider.on('slideChange', function (slider) {
    const idx = slider.realIndex;
    document.querySelector('.hero__image.active').classList.remove('active');
    var activeImage = document.querySelector(`.hero__image[data-idx="${idx}"]`);
    activeImage.classList.add('active');
    aspectHeight(activeImage);
  });  
  
  window.addEventListener('resize', () => {
    var activeUpdateImage = document.querySelector('.hero__image.active');
    aspectHeight(activeUpdateImage);
  });

  gsap.from('.opaque-white-shape', { 
    y: 30,
    duration: 4,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  gsap.from('.transparent-white-shape', { 
    y: -20,
    duration: 4,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  gsap.set('.hero__svg .line', { visibility: 'visible' });
  gsap.fromTo('.hero__svg .line',
    { drawSVG: '100% 100%', duration: 3.5, delay: 1 },
    { drawSVG: '0% 100%', duration: 3.5, delay: 1 }
  );
  
  gsap.from('.hero__svg .line-1', { 
    y: -35,
    duration: 5,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  gsap.from('.hero__svg .line-2', { 
    y: -15,
    duration: 5,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-image-text"] && !Shopify.designMode) return;
  try {
    
  gsap.from('.divider__line-1', { 
    rotation: -.5,
    duration: 4,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  gsap.from('.divider__line-2', { 
    rotation: .5,
    duration: 4,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-pdp-comparison"] && !Shopify.designMode) return;
  try {
    
  const comparisonSlider = new Swiper('.pdp-comparison__charts-mobile', {
    slidesPerView: 2,
    watchOverflow: true,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true
  });

  window.addEventListener('scroll', () => {
    const navWrapper = document.querySelector('.navigation-wrapper');
    const comparisonSection = document.querySelector('.landing__comparison');
    const tableHead = document.querySelector('.table__head');

    // Calculate the bottom position of the navigation-wrapper
    const navWrapperBottom = navWrapper.getBoundingClientRect().bottom;
    // Calculate the top and bottom positions of the landing__comparison section
    const comparisonSectionTop = comparisonSection.getBoundingClientRect().top;
    const comparisonSectionBottom = comparisonSection.getBoundingClientRect().bottom;

    // Add sticky_head when the comparison section touches the navigation-wrapper,
    // and remove it if we scroll past the comparison section
    if (comparisonSectionTop <= navWrapperBottom && comparisonSectionBottom >= navWrapperBottom) {
        tableHead.classList.add('sticky_head');
    } else {
        tableHead.classList.remove('sticky_head');
    }
  });




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-product-slider"] && !Shopify.designMode) return;
  try {
    
  var productSliders = [];
  [...document.querySelectorAll('.product-slider__collection')].forEach((el, i) => {
    var tab = '#' + el.dataset.tab;

    productSliders[i] = new Swiper(tab, {
      slidesPerView: 1.3,
      loop: true,
      spaceBetween: 20,
      watchOverflow: true,
      speed: 400,
      centeredSlides: true,
      threshold: 15,
      watchSlidesProgress: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        prevEl: tab + '--arrow-left',
        nextEl: tab + '--arrow-right'
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        601: {
          slidesPerView: 2.1
        },
        1024: {
          slidesPerView: 2.6,
          loop: false,
          centeredSlides: false,
        },
        1280: {
          slidesPerView: 3,
          loop: false,
          centeredSlides: false,
        },
        1600: {
          slidesPerView: 4,
          loop: false,
          centeredSlides: false,
        }
      }
    });
  });
    
    
    
  // Tab change
  [...document.querySelectorAll('.product-slider__tab')].forEach((el, i) => {
    el.addEventListener('click', event => {
      const el = event.target;
      const tab = el.dataset.tab; 

      if (!el.classList.contains('active')) {
        document.querySelector('.product-slider__tab.active').classList.remove('active');
        el.classList.add('active');

        document.querySelector('.product-slider__collection-wrapper.active').classList.remove('active');
        document.querySelector(`.product-slider__collection-wrapper[data-tab="${tab}"]`).classList.add('active'); 
      }
    }); 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-popup"]) return;
  try {
    
  const legalPopup = document.querySelector('.legal-popup');
  const legalPopupClose = document.querySelector('.legal-popup__close');

  if (getCookie('legalCookie')) {
    legalPopup.classList.remove('is-visible');
  } else {
    legalPopup.classList.add('is-visible');
  }

  legalPopupClose.addEventListener('click', event => {
    const day = legalPopup.dataset.day;

    legalPopup.classList.remove('is-visible');
    setCookie('legalCookie', true, day);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  gsap.set('.main-blog__lines .line', { visibility: 'visible' });
  gsap.fromTo('.main-blog__lines .line',
    { drawSVG: '100% 100%', duration: 3.5, delay: .25 },
    { drawSVG: '0% 100%', duration: 3.5, delay: .25 }
  );

  gsap.from('.main-blog__line-1', { 
    y: -25,
    duration: 4,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  gsap.from('.main-blog__line-2', { 
    y: -15,
    duration: 5,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  // Handle dropdown
  const dropdowns = document.querySelectorAll('.main-blog__filters-dropdown-button');
  dropdowns.forEach(dropdown => {
    dropdown.addEventListener('click', event => {
      dropdown.classList.toggle('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    


  // Product zoom slider
  const productZoomSlider = new Swiper('.product__zoom-slider', {
    loop: true,
    pagination: {
      el: '.product__zoom-pagination',
    },
    navigation: {
      nextEl: '.product__zoom-button.swiper-button-next',
      prevEl: '.product__zoom-button.swiper-button-prev',
    }
  });

  const zoomContainer = document.querySelector('.product__zoom');
  const zoomButtons = document.querySelectorAll('.product__media-zoom');
  zoomButtons.forEach(zoomButton => {
    zoomButton.addEventListener('click', event => {
      const position = Number(event.currentTarget.dataset.position) - 1;

      productZoomSlider.slideToLoop(position);
      setTimeout(() => {
        zoomContainer.classList.add('open');
      }, 250);
    });
  });

  const zoomClose = document.querySelector('.product__zoom-close');
  zoomClose.addEventListener('click', event => {
    zoomContainer.classList.remove('open');
  });

  // Product option dropdowns
  const formDropdownButtons = document.querySelectorAll('.product-form__dropdown-text');
  formDropdownButtons.forEach(formDropdownButton => {
    formDropdownButton.addEventListener('click', event => {
      event.preventDefault();

  	  const dropdown = event.currentTarget.nextElementSibling;
      const parent = event.currentTarget.parentElement;

      if (parent.classList.contains('active')) {
  		parent.classList.remove('active');
        slideUp(dropdown);
      } else {
  		parent.classList.add('active');
        slideDown(dropdown, 200)
      }
    });
  });

  const formDropdownLabels = document.querySelectorAll('.product-form__dropdown-container input[type=radio]+label');
  formDropdownLabels.forEach(formDropdownLabel => {
    formDropdownLabel.addEventListener('click', event => {

      const parent = formDropdownLabel.closest('.product-form__dropdown-wrapper')
      const currentText = formDropdownLabel.innerHTML;
      const newText = parent.querySelector('.product-form__dropdown-text span');

  	  newText.innerHTML = currentText;

  	  const activeDropdown = parent.querySelector('.product-form__dropdown-container')
      parent.classList.remove('active');
      slideUp(activeDropdown, 200);
    });
  });


  // Product dropdowns
  const dropdownButtons = document.querySelectorAll('.product__dropdown-header');

  dropdownButtons.forEach(dropdownButton => {
    dropdownButton.addEventListener('click', event => {
      const parent = event.currentTarget.parentElement;
      const content = parent.querySelector('.product__dropdown-content');
      const activeDropdown = document.querySelector('.product__dropdown.active');

      if (!parent.classList.contains('active')) {
        if (activeDropdown) {
          const activeContent = activeDropdown.querySelector('.product__dropdown-content');

          activeDropdown.classList.remove('active');
          slideUp(activeContent, 300);
        }

        parent.classList.add('active');
        slideDown(content, 300);
      } else {
        parent.classList.remove('active');
        slideUp(content, 300);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modal"]) return;
  try {
    
    if( document.querySelector(".modal__header-shapes-svg") ){
        gsap.set('.modal__header-shapes-line', { visibility: 'visible' });
        gsap.fromTo('.modal__header-shapes-line',
            { drawSVG: '100% 100%', duration: 3.5, delay: 1 },
            { drawSVG: '0% 100%', duration: 3.5, delay: 1 }
        );
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-header-banner"] && !Shopify.designMode) return;
  try {
    
    if( document.querySelector(".page-header-banner__stroke") ){
        gsap.set('.page-header-banner__stroke .page-divider .divider-line', { visibility: 'visible' });

        if(document.querySelector('.page-header-banner__stroke.line-position-top .divider-line')){
            gsap.fromTo('.page-header-banner__stroke .divider-line',
            { drawSVG: '0 0', duration: 3.5, delay: 1 },
            { drawSVG: '100% 0', duration: 3.5, delay: 1 }
        )
        } else if( document.querySelector('.page-header-banner__stroke .divider-line')){
            gsap.fromTo('.page-header-banner__stroke .divider-line',
                { drawSVG: '100% 100%', duration: 3.5, delay: 1 },
                { drawSVG: '0 100% ', duration: 3.5, delay: 1 }
            )
        }

        gsap.from('.page-header-banner__stroke .divider__line-1', {
            rotation: -.5,
            duration: 4,
            ease: 'linear',
            repeat: -1,
            yoyo: true
        });

        gsap.from('.page-header-banner__stroke .divider__line-2', {
            rotation: .5,
            duration: 4,
            ease: 'linear',
            repeat: -1,
            yoyo: true
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-header-grid"]) return;
  try {
    
    if( document.querySelector(".page-header-grid__shape") ){
        gsap.set('.page-header-grid__svg-line', { visibility: 'visible' });
        gsap.fromTo('.page-header-grid__svg-line',
            { drawSVG: '100% 100%', duration: 3.5, delay: 1 },
            { drawSVG: '0% 100%', duration: 3.5, delay: 1 }
        );
        gsap.from('.page-header-grid__svg .light-teal-shape', { 
            y: 10,
            duration: 4,
            ease: 'linear',
            repeat: -1,
            yoyo: true
        });
        gsap.from('.page-header-grid__svg .dark-teal-shape', { 
            y: -20,
            duration: 4,
            ease: 'linear',
            repeat: -1,
            yoyo: true
        });
        gsap.from('.page-header-grid__svg .line-1', {
            rotation: -.5,
            duration: 4,
            ease: 'linear',
            repeat: -1,
            yoyo: true
        });

        gsap.from('.page-header-grid__svg .line-2', { 
            rotation: .5,
            duration: 4,
            ease: 'linear',
            repeat: -1,
            yoyo: true
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-comparison"] && !Shopify.designMode) return;
  try {
    
  const comparisonSlider = new Swiper('.pdp-comparison__charts-mobile', {
    slidesPerView: 2,
    watchOverflow: true,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-specs"] && !Shopify.designMode) return;
  try {
    
  // Tabs
  const specsTabs = document.querySelectorAll('.pdp-specs__tab');
  
  specsTabs.forEach(specTab => {
    specTab.addEventListener('click', event => {
      const tab = event.currentTarget.dataset.tab;
      console.log(tab)

      document.querySelector('.pdp-specs__tab.active').classList.remove('active');
      event.currentTarget.classList.add('active');

      console.log(document.querySelector('.pdp-specs__item.active'))
      document.querySelector('.pdp-specs__item.active').classList.remove('active');
      document.querySelector(`.pdp-specs__item[data-tab="${tab}"]`).classList.add('active');
    });
  });

  // Specs mobile slider
  const specsSlider = document.querySelector('.pdp-specs__specs-images');
  let specsSliderInstance = {};
  const settingsSlider = {
    spaceBetween: 15,
    loop: true,
    pagination: {
      el: '.pdp-specs__pagination',
    }
  }

  window.addEventListener('load', specsSwiperOnLoadOrResize);
  window.addEventListener('resize', specsSwiperOnLoadOrResize);

  function specsSwiperOnLoadOrResize() {
    if (window.innerWidth > 768) {
      if (specsSlider.classList.contains('swiper-initialized')) {
        specsSliderInstance.destroy({
          deleteInstance: true,
          cleanStyles: true
        });
      }
    } else {
      if (!specsSlider.classList.contains('swiper-initialized')) {
        specsSliderInstance = new Swiper('.pdp-specs__specs-images', settingsSlider);
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-x-series-comparison"] && !Shopify.designMode) return;
  try {
    
  const comparisonSlider = new Swiper('.pdp-comparison__charts-mobile', {
    slidesPerView: 2,
    watchOverflow: true,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pets-lp-banner"] && !Shopify.designMode) return;
  try {
    
  const petsLpBannerSlideCount = document.querySelectorAll('.pets-lp-banner__slider .swiper-slide').length;
  const petsLpBannerSlider = new Swiper('.pets-lp-banner__slider', {
    slidesPerView: 1,
    watchOverflow: true,
    loop: petsLpBannerSlideCount > 1,
    spaceBetween: 20,
    allowTouchMove: true,
    autoplay:
      petsLpBannerSlideCount > 1
        ? {
            delay: 5000,
          }
        : false,
    pagination: {
      el: '.pets-lp-banner__pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        allowTouchMove: false,
      },
    },
    on: {
      init: function () {
        const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const elementWithDataIdx0 = document.querySelector('.pets-lp-banner__image[data-idx="0"]');
        if (elementWithDataIdx0) {
          let firstImageRatio;
          if (windowWidth < 768) {
            firstImageRatio = elementWithDataIdx0.querySelector('.aspect-ratio.hide-desktop');
          } else {
            firstImageRatio = elementWithDataIdx0.querySelector('.aspect-ratio.hide-mobile');
          }

          if (firstImageRatio) {
            const firstImagecomputedStyle = window.getComputedStyle(firstImageRatio);
            const firstImagepaddingBottom = parseFloat(firstImagecomputedStyle.paddingBottom);

            const bannerElement = document.querySelector('.pets-lp-banner');
            const isMobile = windowWidth < 768;
            const imageHeightSetting = isMobile 
              ? bannerElement?.getAttribute('data-image-height-mobile')
              : bannerElement?.getAttribute('data-image-height-desktop');

            if (bannerElement && imageHeightSetting === 'image_adaptive') {
              bannerElement.style.height = firstImagepaddingBottom + 'px';
            }
          }
        }
      },
    },
  });

  function aspectHeightPetsLpBanner(activeImage) {
    if (!activeImage) return;

    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    let aspectRatioElement;
    if (windowWidth < 768) {
      aspectRatioElement = activeImage.querySelector('.aspect-ratio.hide-desktop');
    } else {
      aspectRatioElement = activeImage.querySelector('.aspect-ratio.hide-mobile');
    }

    if (aspectRatioElement) {
      const computedStyle = window.getComputedStyle(aspectRatioElement);
      const paddingBottom = parseFloat(computedStyle.paddingBottom);

      const bannerElement = document.querySelector('.pets-lp-banner');
      const isMobile = windowWidth < 768;
      const imageHeightSetting = isMobile 
        ? bannerElement?.getAttribute('data-image-height-mobile')
        : bannerElement?.getAttribute('data-image-height-desktop');

      if (bannerElement && imageHeightSetting === 'image_adaptive') {
        bannerElement.style.height = paddingBottom + 'px';
      }
    }
  }

  petsLpBannerSlider.on('slideChange', function (slider) {
    const idx = slider.realIndex;
    const currentActive = document.querySelector('.pets-lp-banner__image.active');
    if (currentActive) {
      currentActive.classList.remove('active');
    }
    const activeImage = document.querySelector(`.pets-lp-banner__image[data-idx="${idx}"]`);
    if (activeImage) {
      activeImage.classList.add('active');
      aspectHeightPetsLpBanner(activeImage);
    }
  });

  window.addEventListener('resize', () => {
    const activeUpdateImage = document.querySelector('.pets-lp-banner__image.active');
    aspectHeightPetsLpBanner(activeUpdateImage);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["porsche-landing-product"] && !Shopify.designMode) return;
  try {
    
  var porscheLandingProductSliders = [];
  var porscheDesktopBase = 4;
  // Matches the section's CSS breakpoint between mobile and desktop layouts
  var porscheDesktopMQ = window.matchMedia('(min-width: 787px)');
  [...document.querySelectorAll('.porsche-landing-product-slider .product-slider__collection')].forEach((el, i) => {
    var tab = '#' + el.dataset.tab;
    var root = el.closest('.porsche-landing-product-slider');
    var slidesMobile = parseFloat((root && root.dataset.slidesMobile) || '1.15');
    var slidesDesktop = parseFloat((root && root.dataset.slidesDesktop) || '4');
    if (Number.isNaN(slidesMobile)) slidesMobile = 1.15;
    if (Number.isNaN(slidesDesktop)) slidesDesktop = 4;
    var scale = slidesDesktop / porscheDesktopBase;

    var autoplayDesktop = root && root.dataset.autoplayDesktop === 'true';
    var autoplayMobile = root && root.dataset.autoplayMobile === 'true';
    var autoplayDelay = parseInt((root && root.dataset.autoplayDelay) || '5000', 10);
    if (Number.isNaN(autoplayDelay) || autoplayDelay < 1000) autoplayDelay = 5000;
    var anyAutoplay = autoplayDesktop || autoplayMobile;

    var swiperConfig = {
      slidesPerView: slidesMobile,
      loop: false, spaceBetween: 12, watchOverflow: true, speed: 400, threshold: 15, watchSlidesProgress: true,
      navigation: { prevEl: tab + '--arrow-left', nextEl: tab + '--arrow-right' },
      breakpoints: {
        601: { slidesPerView: slidesMobile },
        1024: { slidesPerView: 2.6 * scale },
        1280: { slidesPerView: slidesDesktop },
        1600: { slidesPerView: slidesDesktop }
      }
    };

    if (anyAutoplay) {
      swiperConfig.autoplay = { delay: autoplayDelay, disableOnInteraction: false, pauseOnMouseEnter: true };
    }

    var swiper = new Swiper(tab, swiperConfig);
    porscheLandingProductSliders[i] = swiper;

    if (anyAutoplay && !(autoplayDesktop && autoplayMobile) && swiper.autoplay) {
      var syncAutoplay = function () {
        var isDesktop = porscheDesktopMQ.matches;
        var shouldRun = isDesktop ? autoplayDesktop : autoplayMobile;
        if (shouldRun) { swiper.autoplay.start(); } else { swiper.autoplay.stop(); }
      };
      syncAutoplay();
      if (porscheDesktopMQ.addEventListener) { porscheDesktopMQ.addEventListener('change', syncAutoplay); }
      else if (porscheDesktopMQ.addListener) { porscheDesktopMQ.addListener(syncAutoplay); }
    }
  });

  [...document.querySelectorAll('.porsche-landing-product-slider .product-slider__tab')].forEach((el) => {
    el.addEventListener('click', (event) => {
      const btn = event.currentTarget;
      const tab = btn.dataset.tab;
      const sectionRoot = btn.closest('.porsche-landing-product-slider');
      if (!sectionRoot || btn.classList.contains('active')) return;

      const prevTab = sectionRoot.querySelector('.product-slider__tab.active');
      if (prevTab) prevTab.classList.remove('active');
      btn.classList.add('active');

      const prevWrap = sectionRoot.querySelector('.product-slider__collection-wrapper.active');
      if (prevWrap) prevWrap.classList.remove('active');
      const nextWrap = sectionRoot.querySelector('.product-slider__collection-wrapper[data-tab="' + tab + '"]');
      if (nextWrap) nextWrap.classList.add('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bar"] && !Shopify.designMode) return;
  try {
    
  // Show product bar / hide menu
  const changePoint = document.querySelector('.product').clientHeight - 100;
  const productBar = document.querySelector('.product-bar-wrapper');
  let fromTop = window.scrollY;
  let barIsVisible = productBar.classList.contains('is-visible');

  handleBarVisibility()

  window.addEventListener('scroll', (event) => {
    fromTop = window.scrollY;
    barIsVisible = productBar.classList.contains('is-visible');

    handleBarVisibility()
  });

  function handleBarVisibility() {
    if (fromTop > changePoint) {
      if (!barIsVisible) {
        productBar.classList.add('is-visible');
      }
    } else {
      if (barIsVisible) {
        productBar.classList.remove('is-visible');
      }
    }
  }

  const links = document.querySelectorAll('.product-bar__navigation-item');
  const barHeight = productBar.clientHeight;

  // Highlight on scroll
  window.addEventListener('scroll', (event) => {
    const fromTop = window.scrollY;

    links.forEach(link => {
      const section = document.querySelector(`#${link.dataset.tab}`);

      if (section) {
        if ((section.offsetTop - barHeight - 30) <= fromTop && (section.offsetTop - barHeight - 30) + section.clientHeight > fromTop) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      }
    });
  });

  // Scroll to link
  links.forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      const section = document.querySelector(`#${event.currentTarget.dataset.tab}`)

      window.scrollTo({
        top: section.offsetTop - barHeight - 30,
        behavior: "smooth"
      });
    });
  });

  // Change selections (scroll to top)
  const scrollToTop = document.querySelector('.product-bar__to-top');

  scrollToTop.addEventListener('click', function() {
    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    }), 2000;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  var productSliders = [];
  [...document.querySelectorAll('.product-slider__collection')].forEach((el, i) => {
    var tab = '#' + el.dataset.tab;

    productSliders[i] = new Swiper(tab, {
      slidesPerView: 1.15,
      loop: false,
      spaceBetween: 20,
      watchOverflow: true,
      speed: 400,
      threshold: 15,
      watchSlidesProgress: true,
      navigation: {
        prevEl: tab + '--arrow-left',
        nextEl: tab + '--arrow-right'
      },
      breakpoints: {
        601: {
          slidesPerView: 2.1
        },
        1024: {
          slidesPerView: 2.6
        },
        1280: {
          slidesPerView: 3
        },
        1600: {
          slidesPerView: 4
        }
      },
      on: {
        init() {
          refreshNestedProductCardSwipers(el);
        },
        slideChangeTransitionEnd() {
          refreshNestedProductCardSwipers(el);
        }
      }
    });
  });

  function refreshNestedProductCardSwipers(root) {
    root.querySelectorAll('.product-card-swiper').forEach((carousel) => {
      if (carousel.swiper) {
        carousel.swiper.update();
        carousel.swiper.updateSlides();
        carousel.swiper.updateSize();
      }
    });
    if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.checkElems === 'function') {
      window.lazySizes.loader.checkElems();
    }
  }

  // Tab change
  [...document.querySelectorAll('.product-slider__tab')].forEach((el, i) => {
    el.addEventListener('click', event => {
      const el = event.target;
      const tab = el.dataset.tab; 

      if (!el.classList.contains('active')) {
        document.querySelector('.product-slider__tab.active').classList.remove('active');
        el.classList.add('active');

        document.querySelector('.product-slider__collection-wrapper.active').classList.remove('active');
        const nextWrap = document.querySelector(`.product-slider__collection-wrapper[data-tab="${tab}"]`);
        nextWrap.classList.add('active');

        const nextCollection = nextWrap.querySelector('.product-slider__collection');
        if (nextCollection) {
          // Give the newly shown tab a layout pass before refreshing nested image swipers.
          requestAnimationFrame(() => refreshNestedProductCardSwipers(nextCollection));
        }
      }
    }); 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-how-to"] && !Shopify.designMode) return;
  try {
    
const rewardsHowToSlider = new Swiper('.rewards-how-to__grid', {
  slidesPerView: 1,
  watchOverflow: true,
  loop: false,
  spaceBetween: 20,
  speed: 600,
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 80
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-program"] && !Shopify.designMode) return;
  try {
    
const rewardsProgramSlider = new Swiper('.rewards-program__mobile-table', {
  slidesPerView: 1.8,
  centeredSlides: true,
  loop: true,
  spaceBetween: 0,
  speed: 600
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
  const exploreImageSlider = new Swiper('.shop-by-category__container', {
    slidesPerView: 1.15,
    watchOverflow: true,
    loop: true,
    spaceBetween: 20,
    enabled: true, 
    breakpoints: {
      768: {
        slidesPerView: 3,
        enabled: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-blocks"] && !Shopify.designMode) return;
  try {
    
    const testimonialBlockSlider = new Swiper('.testimonial-blocks__container', {
    slidesPerView: 1,
    spaceBetween: 20,
    allowTouchMove: true,
    pagination: {
      el: '.testimonial-blocks .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  const testimonialLogoSlider = new Swiper('.testimonial-slider__logo-container', {
    slidesPerView: 1,
    watchOverflow: true,
    loop: true,
    spaceBetween: 20,
    effect: 'fade',
    speed: 600,
    allowTouchMove: true, 
    fadeEffect: {
      crossFade: true
    },
    breakpoints: {
      768: {
        speed: 1000
      }
    }
  });

  const testimonialSlider = new Swiper('.testimonial-slider__container', {
    slidesPerView: 1,
    watchOverflow: true,
    loop: true,
    spaceBetween: 20,
    speed: 600,
    autoplay: {
      delay: 3000
    },
    navigation: {
      prevEl: '.testimonial-slider .swiper-button-prev',
      nextEl: '.testimonial-slider .swiper-button-next'
    },
    pagination: {
      el: '.testimonial-slider .swiper-pagination'
    },
    controller: {
      control: testimonialLogoSlider
    },
    breakpoints: {
      768: {
        speed: 1000
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["value-props"] && !Shopify.designMode) return;
  try {
    
  gsap.from('.value-props__item', { 
    x: -20,
    opacity: 0,
    duration: 1,
    ease: 'sine',
    stagger: {
      each: .3,
      from: 'end'
    },
    scrollTrigger: {
      trigger: '.value-props__item',
      start: "top 80%"
    }
  });

  } catch(e) { console.error(e); }
})();
})();
